import { FC, ReactNode } from 'react';

import { PATH_ADMIN, PATH_INDEX, PATH_NFT_TRANSFER } from './routes.constants';

type HeaderMenuItem = {
  title: string;
  href: string;
  isDisable: boolean;
  isNewTab?: boolean;
  icon?: ReactNode;
  submenu?: FC<{ onClose: () => void }> | undefined;
};

export const HEADER_ROUTES: HeaderMenuItem[] = [
  // {
  //   title: 'Fusion',
  //   href: PATH_INDEX,
  //   isDisable: false,
  // },
  {
    title: 'Admin',
    href: PATH_ADMIN,
    isDisable: false,
  },
  {
    title: 'NFT Transfer',
    href: PATH_NFT_TRANSFER,
    isDisable: false,
  },
];

export const ROUTES_MOB: HeaderMenuItem[] = [
  {
    title: 'NFT Transfer',
    href: PATH_INDEX,
    isDisable: false,
  },
];
